module.exports = __webpack_public_path__ + "img/CARTE.374074e2.webp";